import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import NotificationBodyServices from "./NotificationBody.services";


toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getNotificationBody = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_NOTIFICATION_BODY,
      payload: true,
    });
    const resp = await NotificationBodyServices.getNotificationBody(filters);
    dispatch({
      type: actions.GET_NOTIFICATION_BODY,
      payload: {
        notificationBodies: resp.data.data,
        notificationBodiesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.NOTIFICATION_BODY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.NOTIFICATION_BODY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_NOTIFICATION_BODY,
      payload: false,
    });
  }
};

export const getNotificationBodyById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_NOTIFICATION_BODY,
      payload: true,
    });
    const resp = await NotificationBodyServices.getNotificationBodyByID(id);
    dispatch({
      type: actions.GET_NOTIFICATION_BODY,
      payload: {
        notificationBodies: resp.data,
      },
    });
    dispatch({
      type: actions.NOTIFICATION_BODY_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.NOTIFICATION_BODY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_NOTIFICATION_BODY,
      payload: false,
    });
  }
};

export const saveNotificationBody =
  (data, setShowModal, filters) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_NOTIFICATION_BODY,
        payload: true,
      });
      await NotificationBodyServices.saveNotificationBody(data);
      const resp = await NotificationBodyServices.getNotificationBody(filters);
      dispatch({
        type: actions.GET_NOTIFICATION_BODY,
        payload: {
          notificationBodies: resp.data.data,
          notificationBodiesLength: resp.data.count,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_NOTIFICATION_BODY,
        payload: false,
      });
    }
  };

export const editNotificationBody =
  (dataBody, dataEnvio, idBody, idEnvio, setShowModal, filters) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_NOTIFICATION_BODY,
        payload: true,
      });

      //Si se proporciona la información del cuerpo (dataBody), se envía la solicitud de edición del cuerpo de la notificación
      //dataBody: { cuerpo , titulo , pais, estado}
      if (dataBody) {
        await NotificationBodyServices.editNotificationBody(idBody, dataBody);
      }

      //Si se proporciona la información de envío (dataEnvio), se envía la solicitud de edición del envío de la notificación
      //dataEnvio: { fechaInicio, fechaFin, inicioDia, finDia, tipoCorreo, segmento }
      if (dataEnvio) {
        await NotificationBodyServices.editNotificationSending(idEnvio, dataEnvio);
      }

      const resp = await NotificationBodyServices.getNotificationBody(filters);
      dispatch({
        type: actions.GET_NOTIFICATION_BODY,
        payload: {
          notificationBodies: resp.data.data,
          notificationBodiesLength: resp.data.count,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      if (setShowModal)
        setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_NOTIFICATION_BODY,
        payload: false,
      });
    }
  };

export const deleteNotificationBody = (id, filters) => async (dispatch, getState) => {
  try {

    dispatch({
      type: actions.LOADING_NOTIFICATION_BODY,
      payload: true,
    });
    await NotificationBodyServices.deleteNotificationBody(id);
    const resp = await NotificationBodyServices.getNotificationBody(filters);
    dispatch({
      type: actions.GET_NOTIFICATION_BODY,
      payload: {
        notificationBodies: resp.data.data,
        notificationBodiesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.NOTIFICATION_BODY_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.NOTIFICATION_BODY_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_NOTIFICATION_BODY,
      payload: false,
    });
  }
};
